import { defineMessages } from 'react-intl';

export default defineMessages({
    serverError: {
        id: 'api.serverError',
        defaultMessage: 'There was a problem with the server, please try again later.',
    },
})
